import { useState, useEffect } from "react";
import "../../index.css";
import Category from "./Category";
import Services from "./Services";
import Tutorial from "./Tutorial";
import { contFoundPets } from "../../utils";
import HomeSearcher from "./HomeSearcher";
import Carousel from "./Carousel";

// const [foundPets, setFoundPets] = useState(0);

// useEffect(() => {
//   const contPets = async () => {
//     try {
//       const cont = await contFoundPets();
//       setFoundPets(cont);
//     } catch (error) {
//       console.error(
//         "Error al obtener la cantidad de mascotas encontradas",
//         error
//       );
//     }
//   };

//   contPets();
// }, []);

const HomeSection = ({ isMenuOpen }) => {
  return (
    <main className="min-h-[100dvh] pt-16">
      <section className="relative bg-orange-50 flex flex-col items-center sm:h-[80dvh] h-[76dvh] nav:h-[82dvh]">
        <article className="overflow-visible relative z-10 w-full h-[80dvh] nav:h-[76dvh]">
  <div
    className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: `url('/Kira_Levi.jpg')`,
      backgroundPosition: "center 22%",
    }}
  >
    <div className="absolute inset-0 bg-secondary/60"></div>
    <div className="absolute inset-0 opacity-35 Gradient"></div>
  </div>
          
            {/* 
              
              <p className="text-shadow-lg/50 font-main font-regular sm:text-[0.9rem] md:text-2xl text-center macres">
                En BuscaTuAmigo te damos todo lo que necesitás para
                reencontrarte con él desde búsqueda inteligente, carteles listos
                para compartir hasta difusión automática en redes sociales, todo
                en un solo lugar, porque detrás de cada mascota hay un amigo que
                espera volver a su hogar.
              </p>
             */}
          <div className={`relative z-20 w-full h-full flex flex-col items-center justify-center gap-6${!isMenuOpen ? " pt-20" : ""}`}>
  <h1 className="text-white text-shadow-lg/50 sm:text-[50px] md:text-4xl landscape:text-5xl font-main font-medium text-center px-3">
    LA PÁGINA PARA TU AMIGO
  </h1>
  <HomeSearcher />

  {!isMenuOpen && (
    <div className="z-10 flex flex-col gap-2 w-full">
      <Category />
    </div>
  )}
</div>
          
          <div className="absolute bottom-0 w-full">
            <svg
              viewBox="0 0 1440 110"
              className="w-full h-[40px] block"
              preserveAspectRatio="none"
            >
              <path
                d="M0,60 
       C360,140 1080,-110 1440,60 
       L1440,120 L0,120 Z"
                fill="#FDF6ED"
              />
            </svg>
          </div>

        </article>

      </section>

      <Tutorial />
      <Services />

      <section className="adopt bg-orange-50 pt-20 pb-20 flex flex-col w-full justify-between items-center">
        <div className="text-center px-[10dvh]">
          <h2 className="nav:text-4xl text-3xl font-main font-bold">
            ¡Te están esperando!
          </h2>
          <p className="font-main text-md font-medium p-2">
            Si quieres conocer más sobre alguna mascota, haz click en su foto.
          </p>
        </div>

        <Carousel />
      </section>
    </main>
  );
};

export default HomeSection;
